$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

// SCROLLERS
$('.scroller').perfectScrollbar();

$(window).on('resize.scroller', function () {
    $('.scroller').perfectScrollbar('update');
});

var hamburger = $('#hamburger'),
    navbar = $('#navbar');


hamburger.click(function() {
    hamburger.toggleClass('is-active');
    navbar.toggleClass('is-active');
});

var searchInits = $('.navbar-l--search'),
    searchBox = $('#searchBox');

searchInits.click(function(e) {
    e.preventDefault();

    searchBox.addClass('search-box--open');

    $(document).bind('keyup.search', function(e) {
        if(e.which == 27) {
            closeSearch();
        }
    });
});

$('#closeSearchBox').click(function() {
    closeSearch();
});

function closeSearch() {
    searchBox.removeClass('search-box--open');
    $(document).unbind('keyup.search')
}
